'use strict';exports.__esModule = true;exports.authenticationFormatPhoneNumber = exports.normalizePhoneNumber = exports.encodePhoneNumber = exports.splitPhoneNumber = exports.formatPhoneNumber = exports.normalizePhoneAndCountryCode = exports.addPhoneCode = exports.clearPhoneNumber = undefined;var _constants = require('../constants');

var israelCodeRegex = new RegExp('^' + _constants.israelCode, 'g');

var clearPhoneNumber = exports.clearPhoneNumber = function clearPhoneNumber() {var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!phone) {return '';}

  var phoneNumber = typeof phone === 'string' && phone[0] === '+' ? phone.slice(1) : phone;
  return phoneNumber.toString().replace(israelCodeRegex, '0').replace(/\D/g, '');
};

var addPhoneCode = exports.addPhoneCode = function addPhoneCode() {var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return phone.length === 10 ? phone.replace(/^0/i, _constants.israelCode) : phone;};

var normalizePhoneAndCountryCode = exports.normalizePhoneAndCountryCode = function normalizePhoneAndCountryCode() {var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var normalizedValue = phone.replace(/[\D]/g, '');
  var isIsraelCode = countryCode === '+' + _constants.israelCode;

  var formattedPhone = isIsraelCode && normalizedValue.length === 10 ?
  normalizedValue.replace(/^0/i, '') :
  normalizedValue;

  return '' + countryCode + formattedPhone;
};

var checkTreeDigitPrefix = function checkTreeDigitPrefix(array) {
  var threeDigitPrefixNumbers = [1, 5, 7];
  var checkedNumber = parseInt(array[1], 10);
  var isThreeDigitPrefix = threeDigitPrefixNumbers.filter(function (item) {return item === checkedNumber;});
  return !!isThreeDigitPrefix.length;
};

var formatPhoneNumber = exports.formatPhoneNumber = function formatPhoneNumber() {var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var phone = '';
  if (!phoneNumber) {return '';}

  if (phoneNumber.indexOf('-') === -1) {
    var arr = phoneNumber.split('');
    if (checkTreeDigitPrefix(arr)) {
      arr.splice(3, 0, '-');
    } else {
      arr.splice(2, 0, '-');
    }
    phone = arr.join('');
  } else {
    phone = phoneNumber;
  }
  return phone;
};

var splitPhoneNumber = exports.splitPhoneNumber = function splitPhoneNumber() {var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var formatted = formatPhoneNumber(clearPhoneNumber(phone));var _formatted$split =
  formatted.split('-'),prefixPhone = _formatted$split[0],restPhone = _formatted$split[1];
  return { prefixPhone: prefixPhone, restPhone: restPhone };
};

var encodePhoneNumber = exports.encodePhoneNumber = function encodePhoneNumber() {var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var phone = '';
  if (phoneNumber.slice(0, 3).indexOf('-') >= 1) {
    var arr = phoneNumber.split('-');
    var encodePart = arr[1].replaceAll(/[0-9]/g, 'X');
    phone = [arr[0], encodePart].join('-');
  } else if (phoneNumber.indexOf(' ') >= 1) {
    var _arr = phoneNumber.split(' ');
    var encodeParts = _arr.slice(1).map(function (str) {return str.replaceAll(/[0-9]/g, 'X');});
    phone = [_arr[0]].concat(encodeParts).join(' ');
  } else {
    phone = phoneNumber.replaceAll(/[0-9]/g, 'X');
  }
  return phone;
};

var internationalPhoneNumberRegex = /^\+?\d{11,15}$/;
var normalizePhoneNumber = exports.normalizePhoneNumber = function normalizePhoneNumber(phoneNumber) {
  if (!phoneNumber) {return '';}
  var cleanedValue = phoneNumber.replace(/\D/g, '');
  if (internationalPhoneNumberRegex.test(cleanedValue)) {
    return '+' + cleanedValue;
  }

  return '+' + _constants.israelCode + cleanedValue;
};

var authenticationFormatPhoneNumber = exports.authenticationFormatPhoneNumber = function authenticationFormatPhoneNumber(phoneNumber) {
  var cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');

  if (cleanedPhoneNumber.startsWith('0')) {
    return '+' + _constants.israelCode + cleanedPhoneNumber.substring(1);
  } else if (cleanedPhoneNumber.startsWith(_constants.israelCode) || !cleanedPhoneNumber.startsWith('+')) {
    return '+' + cleanedPhoneNumber;
  }

  return cleanedPhoneNumber;
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatPhoneNumber.js
// module id = 45
// module chunks = 0